'use client';

import useScrollRestoration from '@/hooks/useScrollRestoration';

const GlobalHooksWrapper = () => {
  useScrollRestoration();

  return null;
};

export default GlobalHooksWrapper;
